<template>
  <article class="popup popup-padding">
    <header class="popup-top">
      <h2 class="title">{{$t('popups.addRole.title')}}</h2>
      <div class="popup-top_btns">
        <question-btn :text="$t('prompts.addRole')"></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <form class="add-user-form"
          @submit.prevent="addRole">
      <label class="input-cont input-cont_small"
             :class="{'error': $v.name.$error}">
        <p class="label">{{$t('popups.addRole.nameLb')}}</p>
        <input type="text"
               v-model="name"
               @blur="$v.name.$touch()"
               @focus="$v.name.$reset()"
               :placeholder="$t('forms.namePl')">
        <errors v-show="$v.name.$error"></errors>
      </label>

      <!--<upload-avatar @upload="addAvatar($event)"></upload-avatar>-->


      <label class="textarea-wrap">
        <p class="label">
          {{$t('popups.addRole.description')}}
        </p>
        <textarea v-model="desc"
                  :placeholder="$t('popups.addRole.description')"></textarea>
      </label>
      <permission-toggler v-if="routeId || routeItem"
                          @level="level = $event"
                          :default-val="1"
                          class="permission-toggler"></permission-toggler>
      <div class="btns-bottom">
        <button type="button"
                :disabled="loading"
                @click="closeAll"
                class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
        <button type="submit"
                :disabled="$v.$anyError || disableBtn || loading"
                :class="{'loading': loading}"

                class="btn btn-blue">{{$t('btns.create')}}</button>
      </div>
    </form>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import questionBtn from '../questionBtn'
  import {popups} from "../../../mixins/popups";
  import {required, email} from 'vuelidate/lib/validators'
  import errors from '../../Forms/errors'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import uploadAvatar from '../../uploadAvatar'
  import {toFormData} from "../../../mixins/utils/toFormData";
  import permissionToggler from '../../permissionToggler'

  export default {
    name: 'addRolePopup',
    mixins: [popups, tokenAndRoute, toFormData],
    components: {
      closeBtn,
      questionBtn,
      errors,
      uploadAvatar,
      permissionToggler
    },
    data() {
      return {
        name: '',
        avatar: '',
        desc: '',
        level: 1,

        loading: false,

      }
    },
    computed: {
      ...mapState({
        ownedRoles: state => state.roles.ownedRoles,
        mailError: state => state.roles.doubleMailError,
        userData: state => state.auth.user,
        assignedId: state => state.roles.assignedRoleGroup
      }),
      disableBtn() {
        return (!this.name);
      },
    },
    methods: {
      ...mapMutations({
        setMailError: 'roles/SET_DOUBLE_MAIL',
      }),
      ...mapActions({
        getOwnedRoles: 'roles/getOwnedRoles',
        createRole: 'roles/createRole',
        setPermissions: 'projects/setPermissions',
        getProjects: 'projects/getProjects',
      }),
      addAvatar(file) {
        this.avatar = file
      },
      hideMailError() {
        this.setMailError(false)
      },
      async addRole() {
        this.loading = true;
        let data = {
          name: this.name,
          description: this.desc,
          image: this.avatar
        };


        let formData = this.toFormData(data);

        await this.createRole(formData).then(res => {
          this.getProjects()
          if(this.routeId || this.routeItem) {
              let id;
            let obj = {
              value: this.level,
              roles_ids: res.id,
            };

            if (!this.routeItem) {
              obj.project_id = this.routeId
              id = this.routeId
            } else {
              obj.project_item_id = this.routeId
              id = this.routeItem
            };

            this.setPermissions({data: obj, id: id})
              .then(() => {
                this.getOwnedRoles({token: this.token, id: ''});
              })
          } else {
            this.getOwnedRoles({token: this.token, id: ''});
          }
        }).catch(e => {
          this.loading = false
        });


        this.loading = false;
        this.closeAll();
      }
    },
    validations: {
      name: {
        required
      },
    },
    mounted() {
      this.getOwnedRoles({token: this.token, id: ''})
    },

  }
</script>

<style lang="scss" scoped>
  .input-cont {
    margin-bottom: 20px;
  }

  .check-cont {
    margin-top: 20px;
  }

  .select-cont {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .permission-toggler {
    margin: 15px 0;
  }
</style>
